import { GolfTournamentWithFeedCount } from '@/stores/tournaments/tournaments.utils'

type FeedCountKeys = keyof NonNullable<
  GolfTournamentWithFeedCount['count']['matchByExternalId']
>['feedCounts']

type WSDetail = {
  status: boolean
  url: string
}

export const makeWSDetails = (
  tournamentData: GolfTournamentWithFeedCount | null,
  teamNo: number
) => {
  const feedCounts = tournamentData?.count.matchByExternalId?.feedCounts

  return {
    holebyhole: {
      status: !!feedCounts?.holebyhole,
      url: tournamentData
        ? `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${tournamentData?.id}/teamholebyhole/${teamNo}?speed=fast`
        : ''
    },
    rounddetails: {
      status: !!feedCounts?.rounddetails,
      url: tournamentData
        ? `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${tournamentData?.id}/round/1/team/${teamNo}?speed=fast`
        : ''
    },
    playerstats: {
      status: !!feedCounts?.playerstats,
      url: tournamentData
        ? `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${tournamentData?.id}/playerstats/team/${teamNo}?speed=fast`
        : ''
    }
  } as const satisfies Partial<{
    [key in FeedCountKeys]: WSDetail
  }>
}
